import { Box, Icon, Tooltip, Grid, Flex } from "@chakra-ui/react";
import { BsQuestionCircle } from "react-icons/bs";
import { ChevronRightIcon } from "lucide-react";

export const DetailGridItem = ({
  label,
  tooltip,
  children,
  onClick,
}: {
  label: string;
  tooltip?: string;
  children: React.ReactNode;
  onClick?: () => void;
}) => (
  <Grid templateColumns="160px auto" gap={2} py={2} fontSize={14}>
    <Box display="flex" alignItems="center" gap={2}>
      <strong>{label}</strong>
      {tooltip && (
        <Tooltip label={tooltip} placement="top">
          <Box as="span">
            <Icon as={BsQuestionCircle} />
          </Box>
        </Tooltip>
      )}
    </Box>
    <Flex
      onClick={onClick}
      gap={2}
      alignItems="center"
      justifyContent="space-between"
      cursor={onClick ? "pointer" : "default"}
    >
      {children}
      {onClick && <Icon as={ChevronRightIcon} />}
    </Flex>
  </Grid>
);
